import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Form, Modal, Input } from 'antd'
import * as _ from 'lodash'

import * as actions from './actions'

export class DatasourceEditor extends React.Component {


    save = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                var datasource = this.props.datasource._embedded
                const dsLocation = this.props.datasource._links.self.href
                datasource.name = values['name']
                this.props.updateDatasource(dsLocation, datasource)
            }
        });

        this.props.onSaveComplete()
    }


    render() {

        if (!this.props.datasource) {
            return (<div />)
        }
        const FormItem = Form.Item
        const { getFieldDecorator } = this.props.form;
        const datasource = this.props.datasource._embedded
        return (
            <Modal
                {...this.props}
                onOk={this.save}
            >
                <Form  >
                    <FormItem>
                        {getFieldDecorator('name', { initialValue: datasource.name }
                        )(
                            <Input
                                addonBefore='Name'
                                label='Name'
                            />
                        )}

                    </FormItem>
                    {/* <FormItem>
                 {getFieldDecorator('description' , { initialValue: datasource.description }
                    )(
                        <Input
                            addonBefore='Description'
                            label='Description'
                        />
                    )}

                </FormItem> */}
                </Form>
            </Modal>)

    }
}



DatasourceEditor = Form.create()(connect(
    (state, props) => ({
        datasource: _.find(state.datasources.items, ds => {
            return ds._embedded.webSafeString === props.id
        })

    }),
    dispatch => (
        bindActionCreators(actions, dispatch)
    )
)(DatasourceEditor))




// WEBPACK FOOTER //
// ./src/App/Admin/Datasources/DatasourceEditor.jsx